<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth/store'
import { NavigationBar } from '@easybell/caramel-vue3'
import { getEKPUrl } from '@/utils/environment'
import { useCoreStore } from '@/stores/core/store'

import {
  helpLinks,
  myDataLinks,
  myProductLinks,
  phoneSettingsLinks,
  shopLinks,
  userMenuItems,
  languageMenuData,
} from './navbar-data'

const ekpUrl = getEKPUrl()

const coreStore = useCoreStore()

const authStore = useAuthStore()

const navigationMenuData = computed(() => {
  return [
    ...myProductLinks.value,
    ...(!authStore.isOfficeDesk ? myDataLinks.value : []),
    ...phoneSettingsLinks.value,
    ...(!authStore.isOfficeDesk ? shopLinks.value : []),
    ...helpLinks.value,
  ]
})
</script>

<template>
  <nav>
    <NavigationBar
      :logo-link="ekpUrl"
      :navigation-menus-data="navigationMenuData"
      :language-menu-data="languageMenuData"
      :user-menu-items="userMenuItems"
      @set-locale="coreStore.changeLanguage($event)"
      :does-translation-exist="() => true"
    />
  </nav>
</template>
